import { render, staticRenderFns } from "./TableManagerItem.vue?vue&type=template&id=3e2a8291&"
import script from "./TableManagerItem.vue?vue&type=script&lang=ts&"
export * from "./TableManagerItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports